export default {
  name: 'Content section - 6',
  tab: 'content',
  type: 'content-default-section',
  content: {
    title: 'Content section',
    introtext:
      '<p>Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Maecenas sed diam eget risus varius blandit sit amet non magna. Fusce dapibus, tellus ac cursus commodo.</p>',
    image: '',
    buttons: '[]'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image': '',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '100px',
    'padding-bottom': '100px',
    'title-color': 'inherit',
    'title-font-weight': 'lighter',
    'title-tag': 'h2',
    'introtext-color': 'inherit'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'lg',
    'content-horizontal-alignment': 'center',
    'content-box': '0',
    'content-box-color': 'black',
    'content-box-padding': '30px',
    'content-box-opacity': '0.5',
    'content-box-elevation': '0',
    'content-box-border': '0',
    'content-box-border-color': 'var(--text-dark-color)',
    'content-box-rounded': '0',
    'content-vertical-alignment': 'start',
    'image-size': 'sm',
    'image-position': 'left'
  },
  advanced: {}
}
